module.exports = __webpack_public_path__ + "img/flavor_blue_punch.5854ccbc.png";